import { navItems } from "@/mocks/home";

export default function SiteFooter() {
  const go = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <footer className="w-full">
      <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100/60">
        <div className="max-w-4xl mx-auto rounded-lg border border-background-300 bg-background-50 p-5 md:p-7">
          <h2 className="font-heading font-bold text-foreground-950 text-lg flex items-center gap-2">
            <i className="ri-error-warning-line text-accent-500"></i>
            使用须知与免责声明
          </h2>
          <div className="mt-4 space-y-3 text-sm text-foreground-700 leading-relaxed">
            <p>
              本页面为<strong className="text-foreground-900">信息指引类内容</strong>，用于说明如何查找入口、如何应对地址变化、
              如何安全获取安装包以及如何使用网页版浏览，并非任何站点的官方页面，也不提供漫画内容的下载或存储服务。
            </p>
            <p>
              页面中涉及的判断方法与安全提醒属于通用建议，具体站点的域名、地址与下载渠道请以你实际核对的官方信息为准。
              对于第三方页面的内容与服务，本页不承担相应责任。请在遵守当地法律法规的前提下合理使用网络资源。
            </p>
            <p>
              如在访问过程中遇到索要账号密码、支付信息或验证码的页面，请立即退出，不要提交任何敏感资料。
            </p>
          </div>
        </div>
      </section>

      <div className="w-full px-4 md:px-6 py-12 md:py-14 bg-primary-950 text-background-100">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
                <i className="ri-book-2-line text-lg"></i>
              </span>
              <span className="font-heading font-bold text-lg">老司机漫画 · 入口指南</span>
            </div>
            <p className="mt-4 text-sm text-background-200 leading-relaxed max-w-md">
              把「官网入口、最新地址、APP 下载、在线看网址」整理成一页，帮你快速进入正确页面，
              不再为网址失效或频繁换地址而反复搜索。
            </p>
          </div>

          <div className="lg:col-span-4">
            <h3 className="font-label font-medium text-background-100 text-sm">本页导航</h3>
            <div className="mt-4 flex flex-wrap gap-x-6 gap-y-2.5">
              {navItems.map((item) => (
                <a
                  key={item.id}
                  href={`#${item.id}`}
                  onClick={(e) => {
                    e.preventDefault();
                    go(item.id);
                  }}
                  className="text-sm text-background-200 hover:text-primary-300 transition-colors whitespace-nowrap"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          <div className="lg:col-span-3">
            <h3 className="font-label font-medium text-background-100 text-sm">快速操作</h3>
            <div className="mt-4 flex flex-col gap-2.5">
              <button
                onClick={() => go("entry-channel")}
                className="inline-flex items-center gap-2 text-sm text-background-200 hover:text-primary-300 transition-colors cursor-pointer text-left"
              >
                <i className="ri-compass-3-line"></i> 查看官网入口
              </button>
              <button
                onClick={() => go("top")}
                className="inline-flex items-center gap-2 text-sm text-background-200 hover:text-primary-300 transition-colors cursor-pointer text-left"
              >
                <i className="ri-arrow-up-line"></i> 返回页面顶部
              </button>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-900 flex flex-col sm:flex-row sm:items-center justify-between gap-3">
          <p className="text-xs text-background-300">
            © 2026 老司机漫画入口指南 · 内容维护至 2026-10-10
          </p>
          <p className="text-xs text-background-300">
            本页为信息指引，请以官方公布信息为准
          </p>
        </div>
      </div>
    </footer>
  );
}